module.exports = __webpack_public_path__ + "cb2b89d20f2944412becb68f5504fa35.pdf";